module.exports = __webpack_public_path__ + "components/flag/static/square/is-bb910a71e14578c3200a440165994486.svg";